module.exports = __webpack_public_path__ + "static/img/a103.8786047.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a103.jpg
// module id = aOjj
// module chunks = 0